module.exports = __webpack_public_path__ + "img/users.f69f00c6.svg";